import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ITabSearchData } from "./navigateTab.props";
import { tabDatas } from "./navigateTab.data";

const SCROLL_KEY = "tabNavScrollX";

const NavigateTabs = ({ tabCurrent }: { tabCurrent: ITabSearchData }) => {
    const navigate = useNavigate();
    const scrollRef = useRef<HTMLDivElement>(null);
    const menuSort = tabDatas?.slice()?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    useEffect(() => {
        const saved = sessionStorage.getItem(SCROLL_KEY);
        if (scrollRef.current && saved) {
            scrollRef.current.scrollLeft = parseInt(saved, 10);
        }
    }, []);

    const handleNavigate = (link: string) => {
        if (scrollRef.current) {
            sessionStorage.setItem(SCROLL_KEY, scrollRef.current.scrollLeft.toString());
        }
        navigate(link);
    };

    return (
        <div
            ref={scrollRef}
            className="flex items-center overflow-x-auto overflow-y-hidden no-scrollbar-disable snap-x snap-mandatory"
        >
            {menuSort?.map((tab, index) => (
                <div
                    key={index}
                    className={`shrink-0 snap-start group flex justify-center items-center px-[22px] py-[8px] mr-[10px] last:mr-0 rounded-[20px] cursor-pointer ${
                        tab.id === tabCurrent.id
                            ? "bg-[#0971A2]"
                            : "border border-[#0971A2] border-solid customDesktop:hover:bg-[#0971A2]"
                    }`}
                    onClick={() => handleNavigate(tab.link)}
                >
                    {tab.icon(
                        tab.id === tabCurrent.id
                            ? "fill-white text-white"
                            : "fill-[#0971A2] text-[#0971A2] customDesktop:group-hover:!fill-white customDesktop:group-hover:!text-white"
                    )}
                    <p
                        className={`ml-[10px] text-[12px] font-normal ${
                            tab.id === tabCurrent.id ? "text-white" : "text-[#0971A2] customDesktop:group-hover:!text-white"
                        }`}
                    >
                        {tab.label}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default NavigateTabs;